module.exports = __webpack_public_path__ + "static/media/scrollright.68f94cf7.jpg";